import React, { useContext } from 'react';
import { array } from 'prop-types';
import { AppContext } from '../AppContext';

import MapIcon from './MapIcon';

const MobileAllPlaces = ({ className, filtered }) => {
  const { onClick, theme } = useContext(AppContext);
  function computeName(item) {
    if(!item && !item.value) {
      return "";
    }
    if(item.value === item.country) {
      return 'country_name';
    }
    if(item.value === item.state_name) {
      return 'state_name';
    }
    if(item.value === item.city) {
      return 'city';
    }
    const splitVal = item.value.split(',').map((item) => {
      return (item) ? item.trim() : "";
    });
    let keyString = '';
    splitVal.forEach((element, index) => {
      if(element) {
          if(index === 0 && element === item.city) {
            keyString += 'city-';
            return;
          }
          if(index === 1 & element === item.state_name ) {
            keyString += 'state_name-';
            return;
          }
          if(index === 2 && element === item.country) {
            keyString += 'country_name';
            return;
          }
      }else {
        console.log("Element is empty after spilt on index"+ index);
      }
    });
    return keyString;
  }

  /*const allPlaces = filtered.map((item, index) => {
    return (
      <button
        key={index}
        onClick={onClick}
        className={className}
        style={{ textAlign: 'left' }}
      >
        <span>{item.value}</span>
        {item.data && (
          <div className="autocomplete-group">
            {item.data && item.data.location}
          </div>
        )}
      </button>
    );
  });*/

  const allPlaces = filtered.map((item, index) => {
    if (!item.data) {
      // cities, states, and countries
      return (
        <button
          key={index}
          onClick={onClick}
          className={className}
          style={{ textAlign: 'left' }}
          data-value={item.value}
          data-filter-key={computeName(item)}
        >
          <MapIcon alt={theme.alt} src={theme.src} />
          <span>{item.value.replace(/,\s?,/g, ',')}</span>
        </button>
      );
    } else if (item.data) {
      // addresses associated with hotels
      return (
        <button
          key={index}
          onClick={onClick}
          className={className}
          style={{ textAlign: 'left' }}
          data-value={item.data && item.data.location}
          data-filter-key="city-state_name-country_name"
        >
          <span>{item.value}</span>
          {item.data && (
            <div className="autocomplete-group">
              {item.data && item.data.location.replace(/,\s?,/g, ',')}
            </div>
          )}
        </button>
      );
    }
  });
  
  return allPlaces;
};

MobileAllPlaces.propTypes = {
  filtered: array.isRequired
};

export default MobileAllPlaces;
